import React from "react";
import SectionHeader from "../../components/SectionHeader";
import HeaderImage from "../../images/main-banner.png";
import HeaderImage2 from "../../images/banner-side -image.png";
import { Container } from "react-bootstrap";
const TermsConditions = () => {
  return (
    <>
      <SectionHeader
        title="Privacy Policy"
        image={HeaderImage}
        image2={HeaderImage2}
        title2="Privacy Policy"
        content="At BOLT-CORP, we are committed to protecting and respecting your
              privacy. This Privacy Policy explains how we collect, use, and
              safeguard your personal information when you visit our website or
              engage with our services."
      ></SectionHeader>
      <div className="pt-5">
        <Container>
          <div className="pt-5 pb-4">
            <p>
              <strong>Information We Collect: </strong>
              We collect personal information you provide when registering for
              an account, making a purchase, or contacting us for customer
              support. This may include your name, email address, phone number,
              shipping address, and payment details.
            </p>
            <p>
              <strong>How We Use Your Information: </strong>
              <ul>
                <li>Process orders and manage transactions.</li>
                <li>Provide customer service and support.</li>
                <li>Improve our products and services.</li>
                <li>Send marketing communications (with your consent).</li>
                <li>Comply with legal obligations.</li>
              </ul>
            </p>
            <p>
              <strong>How We Protect Your Information: </strong>
              We implement a variety of security measures to ensure that your
              personal information is protected when you make a purchase,
              register on our site, or access your personal information. These
              security measures include encrypted communication and secure
              servers.
            </p>
            <p>
              <strong>Sharing Your Information: </strong>
              We do not sell, trade, or transfer your personal information to
              third parties without your consent, except when necessary to
              provide services (such as shipping) or as required by law.
            </p>
            <p>
              <strong>Cookies and Tracking Technologies: </strong>
              We use cookies and other tracking technologies to enhance user
              experience on our site. These tools help us understand how users
              navigate our site, enabling us to improve functionality and
              personalize your experience.
            </p>
            <p>
              <strong>Third-Party Links: </strong>
              Our website may contain links to third-party websites. These
              third-party sites have separate privacy policies; we are not
              responsible for their content or practices.
            </p>
            <p>
              <strong>Your Rights and Choices: </strong>
              You can access, update, or delete your personal information. You
              can opt out of receiving marketing emails by following the
              unsubscribe instructions in those emails.
            </p>
            <p>
              <strong>Changes to This Privacy Policy: </strong>
              We may update this Privacy Policy occasionally. Any changes will
              be posted on this page with an updated "Last Revised" date.
            </p>
            <p>
              <strong>Contact Us: </strong>
              If you have any questions or concerns about this Privacy Policy or
              your personal information, please get in touch with us at [contact
              information].
            </p>
            <p>
              You consent to the practices outlined in this Privacy Policy by
              using our website and services.
            </p>
          </div>
        </Container>
      </div>
    </>
  );
};

export default TermsConditions;
